import ActionButton from '../../../../common/components/documentViewer/actionButton';
import { IActionButtonCommonProps } from '../../../../common/typings/DocumentViewer/actionButtonCommonProps';
import { OrderDocumentOptions, ViewInLibraryStatus } from '../../typing/enums';
import { IOrderViewerMainStore } from '../../typing/stores';
import { isOrderDrm } from '../../utils/orderUtils';
import RedirectHelper from '../../utils/redirectHelper';
import { Icons } from 'copyright-clearance-center-common-ui';
import { inject } from 'mobx-react';

interface IViewInLibraryProps {
	redirectHelper?: RedirectHelper;
	documentId?: number;
	viewInLibraryStatus?: ViewInLibraryStatus;
	options?: OrderDocumentOptions;
}

const ViewInLibraryButton: React.FunctionComponent<IViewInLibraryProps & IActionButtonCommonProps> = props => {
	const handler = () => {
		props.redirectHelper.redirectToLibrary(props.documentId);
	};

	const isDrm: boolean = isOrderDrm(props.options);

	return (
		<ActionButton
			label={localize('View in library')}
			handler={handler}
			icon={Icons.LibraryViewIcon}
			isPrimary={props.isPrimary}
			disabled={props.viewInLibraryStatus !== ViewInLibraryStatus.Enabled || isDrm}
			useContained={true}
			testId="view-in-library-btn"
			controlledBy={props.controlledBy}
		/>
	);
};

export default inject((stores: IOrderViewerMainStore) => ({
	redirectHelper: stores.redirectHelper,
	documentId: stores.orderViewerStore.libraryDocumentId,
	viewInLibraryStatus: stores.orderViewerStore.viewInLibraryStatus,
	options: stores.orderViewerStore.viewModel.documentModel.documentOptions
}))(ViewInLibraryButton);
